var exports = {
  "Tq": "x61f99309--ce13bb--bubble",
  "hD": "x61f99309--ce13bb--quote",
  "Zp": "x61f99309--ce13bb--layout",
  "Qs": "x61f99309--ce13bb--content",
  "mI": "x61f99309--ce13bb--meta",
};

module.exports = exports;
